import { uzLatnToCyrl } from '../i18n/translit';
import type { I18nText, LabDefinition, Locale } from './schema';

/** Matnni tanlangan tilda; yo'q bo'lsa uz-Latn (uz-Cyrl uchun avtomatik translit). */
export function localize(text: I18nText, locale: Locale): string {
  const v = text[locale];
  if (v !== undefined) return v;
  if (locale === 'uz-Cyrl') return uzLatnToCyrl(text['uz-Latn']);
  return text['uz-Latn'];
}

function fill(t: I18nText): I18nText {
  return t['uz-Cyrl'] !== undefined ? t : { ...t, 'uz-Cyrl': uzLatnToCyrl(t['uz-Latn']) };
}

/** Lab ta'rifidagi barcha I18nText larga yetishmagan uz-Cyrl ni qo'shadi (yangi obyekt). */
export function fillCyrillic(lab: LabDefinition): LabDefinition {
  return {
    ...lab,
    title: fill(lab.title),
    subject: fill(lab.subject),
    objective: fill(lab.objective),
    theory: fill(lab.theory),
    procedure: lab.procedure.map(fill),
    controls: lab.controls.map((c) => ({
      ...c,
      label: fill(c.label),
      ...(c.options ? { options: c.options.map((o) => ({ ...o, label: fill(o.label) })) } : {}),
    })),
    sensors: lab.sensors.map((s) => ({ ...s, label: fill(s.label) })),
    schematic: {
      ...lab.schematic,
      labels: Object.fromEntries(
        Object.entries(lab.schematic.labels).map(([k, v]) => [k, fill(v)]),
      ),
    },
    report: {
      ...lab.report,
      fields: lab.report.fields.map((f) => ({
        ...f,
        label: fill(f.label),
        ...(f.hint ? { hint: fill(f.hint) } : {}),
      })),
    },
  };
}
